import { render } from "./ReferenceTypeDetail.vue?vue&type=template&id=5832a1f8"
import script from "./ReferenceTypeDetail.vue?vue&type=script&lang=js"
export * from "./ReferenceTypeDetail.vue?vue&type=script&lang=js"

import "./ReferenceTypeDetail.vue?vue&type=style&index=0&id=5832a1f8&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__